import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";
import { baseUrl } from "../../../api/baseUrl";

export const likedCommentsApi = createApi({
  reducerPath: "likedCommentsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}/api/v1/provider`,
    prepareHeaders: (headers) => {
      const token = Cookies.get("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  tagTypes: ["LikedComments"],
  endpoints: (builder) => ({
    getLikedComments: builder.query({
      query: () => "brand/comment-likes",
      providesTags: ["LikedComments"],
    }),
    addCommentLike: builder.mutation({
      query: (commentId) => ({
        url: `comment/${commentId}/like`,
        method: "POST",
      }),
      // Disable automatic refetch
      invalidatesTags: [],
      // Optimistic update
      async onQueryStarted(commentId, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          likedCommentsApi.util.updateQueryData(
            "getLikedComments",
            undefined,
            (draft) => {
              if (!draft?.data?.includes(commentId)) {
                draft?.data.push(commentId);
              }
            }
          )
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    removeCommentLike: builder.mutation({
      query: (commentId) => ({
        url: `comment/${commentId}/unlike`,
        method: "DELETE",
      }),
      // Disable automatic refetch
      invalidatesTags: [],
      // Optimistic update
      async onQueryStarted(commentId, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          likedCommentsApi.util.updateQueryData(
            "getLikedComments",
            undefined,
            (draft) => {
              const index = draft?.data?.indexOf(commentId);
              if (index > -1) {
                draft?.data.splice(index, 1);
              }
            }
          )
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetLikedCommentsQuery,
  useAddCommentLikeMutation,
  useRemoveCommentLikeMutation,
} = likedCommentsApi;
